module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_2_B-00e5aff1c0308dc5bf05d021bae2ec2d.gif";